// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/UI/Backdrop/Backdrop.css
// module id = 612
// module chunks = 0